"use client";

import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ChatWindow } from "@/components/chat/ChatWindow";
import { useChatStore } from "@/lib/chat-store";
import { useOverlayStore } from "@/lib/overlay-store";
import { useTenant } from "@/components/TenantProvider";
import Navbar from "@/components/navigation/Navbar";
import FloatingDock from "@/components/navigation/FloatingDock";

export default function AdminLayout() {
  const { pathname } = useLocation();
  const { tenant } = useTenant();

  useEffect(() => {
    const store = useChatStore.getState();
    store.setAdminMode(true);
    store.setCurrentTenantId(tenant.id);
    return () => store.setAdminMode(false);
  }, [tenant.id]);

  const resetOverlays = useOverlayStore((s) => s.activeCount > 0);
  useEffect(() => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflowY = "";
    if (resetOverlays) useOverlayStore.setState({ activeCount: 0 });
  }, [pathname]);

  useEffect(() => {
    document.title = `Admin — ${tenant.name}`;
  }, [tenant]);

  return (
    <div className="relative min-h-screen bg-light-bg dark:bg-dark-bg">
      <Navbar />
      <main className="pt-14 pb-24 overflow-x-hidden">
        <div className="p-3 sm:p-4 md:p-6 lg:p-8"><Outlet /></div>
      </main>
      <FloatingDock />
      {tenant.settings.features?.chat !== false && <ChatWindow />}
    </div>
  );
}
